import { combineReducers } from 'redux';

import genericErrorReducer from 'modules/global/reducers/generic.error';
import genericLoadingReducer from 'modules/global/reducers/generic.loading';
import genericPageReducer from 'modules/global/reducers/generic.page';
import * as types from 'modules/statistics/actionTypes';

import data from './data';
import filters from './filters';

export default combineReducers({
  data,
  filters,
  page: genericPageReducer(types.FETCH_PROACTIVE_WORKS_DETAILS_STATS),
  apiError: genericErrorReducer(types.FETCH_PROACTIVE_WORKS_DETAILS_STATS),
  loading: genericLoadingReducer(types.FETCH_PROACTIVE_WORKS_DETAILS_STATS),
});
